/* global Office */
import * as React from 'react';
import { PhoenixAuthService } from './PhoenixAuthService';

class AuthContainerPhoenix extends React.Component {
	constructor(props) {
		super(props);
		this.authService = new PhoenixAuthService();
		this.shouldCancel = false;
	}

	componentDidMount() {
		this.getUser();
	}

	componentWillUnmount() {
		this.shouldCancel = true;
	}

	login = () => {
		this.authService.login();
	};

	renewToken = () => {
		this.authService
			.renewToken()
			.then(() => {
				console.log("authContainer  renewToken :::",renewedUser);
				this.getUser();
			})
			.catch(error => {
				return error;
			});
	};

	logout = () => {
		this.authService.logout();
	};

	getUser = () => {
		this.authService.getUser().then(user => {
			if (user && !this.shouldCancel) {
				Office.onReady().then(() => {
					Office.context.ui.messageParent(
						JSON.stringify({ status: 'success', result: user }),
					);
				});
			} else {
				this.login();
			}
		});
	};

	render() {
		return <p>Redirecting!</p>;
	}
}
export default AuthContainerPhoenix;
